'use strict';
module.exports = {
	formatVersion: 3,
	id: 'root',
	ideas: {
		1: {
			title: 'Press Space or double-click to edit',
			id: 1
		}
	}
};
